<template>
  <form id="form" v-loading="loading"  role="form" @submit.prevent="onFormSubmit">
      <div class="row" v-if="!signatureCreate">
        <div class="col-md-3 text-right align-self-center">
          Confirmar contraseña
        </div>
        <div class="col-md-6 text-right align-self-center">
          <fg-input
            label=""
            v-model="formData.password"
            :class="'has-label input-lg ' + classValidation"
            type="password"
          ></fg-input>
        </div>
        <div class="col-md-3 text-left">
          <n-button class="btn btn-round" native-type="submit" v-if="!signatureCreate">
            {{$t('profile.button_signature')}}
          </n-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-right align-self-center">
          Firma Digital
        </div>
        <div class="col-md-6">
          <el-input
            :disabled="true"
            type="textarea"
            :rows="3"
            v-model="formData.signature">
          </el-input>
        </div>

        <div class="col-md-3 ">
          
        </div>
      </div>
  </form>
</template>
<script>
import { Card, FormGroupInput, Button, Alert } from '@/components';
import { MessageBox, Message, Input } from 'element-ui';
import Auth from '@/providers/Auth'

const AuthProvider = new Auth()

export default {
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    Alert,
    [Input.name]: Input
  },
  props: [
    'userId'
  ],
  beforeMount(){
    this.checkSignature()
  },
  data: () => ({
      formData: {
        password: null,
        signature: null
      },
      signature: null,
      loading: false,
      signatureCreate: false,
      classValidation: ''
  }),
  methods: {
    checkSignature(){
      this.formData.signature = this.$store.state.signature
      this.signatureCreate = this.$store.state.signature ? true : false
      this.signature = this.formData.signature
    },
    onFormSubmit () {
      if(!this.formData.password) {
        this.classValidation = "has-danger"
      } else{
        this.classValidation = "has-success"
        this.loading = true
        AuthProvider.signature(this.userId, this.formData).then((resp)=> {
          let signature = resp.data.signature
          this.formData.signature = signature
          this.$store.dispatch('SET_SIGNATURE', signature).then(() => {
            this.loading = false
            this.checkSignature()
          })
          .catch((err) => {
            this.loading = false
          })
        }).catch((err)=>{
          Message({ type: 'error', message: 'Datos incorrectos' })
          this.loading = false
          this.classValidation = "has-danger"
        })
      }
    }
  },
  watch: {
    signature(){
      this.$emit('input', this.signature);
    }
  }
};
</script>
<style></style>
